var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var _a, _b, _c;
import { action, autorun, makeObservable, observable, runInAction } from 'mobx';
import { BaseSingletonService, Singleton } from './service.base';
import { UIOpenService } from './service.ui';
import { api } from '~/tools/api/api';
import { ServiceConfig } from '~/services/service.config';
import { EApiUrl } from '~/tools/api/types';
import { EUserLocalStorageKey, EUserRoles } from '~/shared/types';
import Cookies from 'js-cookie';
export let AuthService = class AuthService extends BaseSingletonService {
    openPassSvc;
    openDialogSvc;
    serviceConfig;
    isLogged = false;
    constructor(openPassSvc, openDialogSvc, serviceConfig) {
        super();
        this.openPassSvc = openPassSvc;
        this.openDialogSvc = openDialogSvc;
        this.serviceConfig = serviceConfig;
        makeObservable(this);
        autorun(this.useLocalStorage);
    }
    autoSignIn(hash) {
        return api
            .get(`${EApiUrl.autoSignIn}`, {
            params: {
                id: hash,
            },
        })
            .then(response => {
            if (response.data?.model?.user) {
                this.setAuthInfo(response.data.model.user.role, response.data.model.user.id);
                this.setUserSession(response.data.model.user.session);
            }
            return response;
        });
    }
    login = async (data) => {
        try {
            const response = await api.post(EApiUrl.auth, data);
            if (response.statusText?.toLowerCase() === 'ok' && response.data?.user) {
                this.self.setAuthInfo(response.data.user.role, response.data.user.id);
                const [, ...path] = window.location.hostname.split('.');
                this.setUserSession(response.data.user.session, { domain: path ? `.${path.join('.')}` : undefined });
            }
        }
        catch (error) {
            this.self.setAuthInfo();
        }
    };
    logout = () => {
        api.delete(`${EApiUrl.auth}/${this.getUserId()}`).then(() => {
            this.setAuthInfo();
        });
    };
    setAuthInfo = (userRole, userId) => {
        if (userRole) {
            localStorage.setItem(EUserLocalStorageKey.userRole, String(userRole));
            userId && localStorage.setItem(EUserLocalStorageKey.userId, String(userId));
        }
        else {
            localStorage.removeItem(EUserLocalStorageKey.userRole);
            localStorage.removeItem(EUserLocalStorageKey.userId);
        }
        this.self.isLogged = this.self.isLoggedIn();
    };
    setUserSession(userSession, options) {
        if (!userSession) {
            return;
        }
        Cookies.set(userSession.name, userSession.id, options);
    }
    isLoggedIn() {
        const userRole = this.getUserRole();
        if (userRole === null) {
            return false;
        }
        return userRole === EUserRoles.user || userRole === EUserRoles.admin || userRole === EUserRoles.unconfirmed;
    }
    isUserHasSomeRole(accessLevels) {
        const userRole = this.getUserRole();
        return !!userRole && accessLevels.includes(userRole);
    }
    getUserRole() {
        return localStorage.getItem(EUserLocalStorageKey.userRole);
    }
    getUserId() {
        return localStorage.getItem(EUserLocalStorageKey.userId);
    }
    useLocalStorage = () => {
        runInAction(() => {
            this.self.isLogged = this.isLoggedIn();
        });
    };
};
__decorate([
    observable,
    __metadata("design:type", Boolean)
], AuthService.prototype, "isLogged", void 0);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [String]),
    __metadata("design:returntype", void 0)
], AuthService.prototype, "autoSignIn", null);
__decorate([
    action,
    __metadata("design:type", Object)
], AuthService.prototype, "login", void 0);
__decorate([
    action,
    __metadata("design:type", Object)
], AuthService.prototype, "logout", void 0);
__decorate([
    action,
    __metadata("design:type", Object)
], AuthService.prototype, "setAuthInfo", void 0);
AuthService = __decorate([
    Singleton(),
    __metadata("design:paramtypes", [typeof (_a = typeof UIOpenService !== "undefined" && UIOpenService) === "function" ? _a : Object, typeof (_b = typeof UIOpenService !== "undefined" && UIOpenService) === "function" ? _b : Object, typeof (_c = typeof ServiceConfig !== "undefined" && ServiceConfig) === "function" ? _c : Object])
], AuthService);
